var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortDownAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.483,
    height: 17.923,
    viewBox: "0 0 20.483 17.923",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-sort-amount-down-alt",
    "data-name": "Icon awesome-sort-amount-down-alt",
    d: "M9.6,4.81h2.56a.64.64,0,0,0,.64-.64V2.89a.64.64,0,0,0-.64-.64H9.6a.64.64,0,0,0-.64.64V4.17A.64.64,0,0,0,9.6,4.81Zm0,5.121h5.121a.64.64,0,0,0,.64-.64V8.011a.64.64,0,0,0-.64-.64H9.6a.64.64,0,0,0-.64.64v1.28A.64.64,0,0,0,9.6,9.931Zm10.242,7.681H9.6a.64.64,0,0,0-.64.64v1.28a.64.64,0,0,0,.64.64H19.843a.64.64,0,0,0,.64-.64v-1.28A.64.64,0,0,0,19.843,17.613ZM9.6,15.052h7.681a.64.64,0,0,0,.64-.64v-1.28a.64.64,0,0,0-.64-.64H9.6a.64.64,0,0,0-.64.64v1.28A.64.64,0,0,0,9.6,15.052Zm-2.56,0H5.121V2.89a.64.64,0,0,0-.64-.64H3.2a.64.64,0,0,0-.64.64V15.052H.64a.64.64,0,0,0-.452,1.093l3.2,3.841a.64.64,0,0,0,.9,0l3.2-3.841A.641.641,0,0,0,7.041,15.052Z",
    transform: "translate(0 -2.25)",
    fill: "#323444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortDownAlt);
export default __webpack_public_path__ + "static/media/sort-down-alt.9763e1b86726cdc1da64fb18a550dfa5.svg";
export { ForwardRef as ReactComponent };